import React from 'react';

/**
 * Función utilitaria para crear notificaciones con colores personalizados
 * Compatible tanto con componentes funcionales como de clase
 */
export const createStyledNotification = (message, type = 'info', options = {}) => {
  // Configurar duración según el tipo
  const config = {
    success: { duration: 4000 },
    error: { duration: 6000 },
    warning: { duration: 5000 },
    info: { duration: 4000 }
  };

  const notificationConfig = config[type] || config.info;
  
  // Función para aplicar estilos a la notificación
  const applyNotificationStyles = () => {
    // Buscar el contenedor de notificación más reciente
    const snackbarContainers = document.querySelectorAll('.MuiSnackbarContent-root');
    const latestSnackbar = snackbarContainers[snackbarContainers.length - 1];
    
    if (latestSnackbar) {
      // Remover clases anteriores
      latestSnackbar.classList.remove('notification-success', 'notification-error', 'notification-warning', 'notification-info');
      // Agregar la clase correspondiente al tipo
      latestSnackbar.classList.add(`notification-${type}`);
      
      // También aplicar estilos inline como respaldo
      const colors = {
        success: '#4caf50',
        error: '#f44336',
        warning: '#ff9800',
        info: '#2196f3'
      };
      
      latestSnackbar.style.backgroundColor = colors[type] || colors.info;
      latestSnackbar.style.color = '#fff';
    }
  };

  // Usar MutationObserver para detectar cuando se agrega la notificación al DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('MuiSnackbarContent-root')) {
            applyNotificationStyles();
            observer.disconnect(); // Desconectar después de aplicar los estilos
          }
        });
      }
    });
  });

  // Observar cambios en el body
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Respaldo con timeout por si el observer no funciona
  setTimeout(() => {
    applyNotificationStyles();
    observer.disconnect();
  }, 200);
  
  // Crear el mensaje simple con icono
  const customMessage = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {getIcon(type)}
      <span style={{ marginLeft: '8px' }}>{message}</span>
    </div>
  );

  return {
    message: customMessage,
    type,
    options: {
      duration: notificationConfig.duration,
      ...options
    }
  };
};

/**
 * Hook personalizado que extiende useNotify de react-admin
 * para mostrar notificaciones con diferentes colores según el tipo
 */
export const useNotificationWithColors = () => {
  const showNotification = (message, type = 'info', options = {}) => {
    const notification = createStyledNotification(message, type, options);
    
    // Retornar los datos formateados para usar con showNotification de react-admin
    return notification;
  };

  return showNotification;
};

/**
 * Función helper para obtener el icono según el tipo
 */
const getIcon = (type) => {
  const iconStyle = { fontSize: '20px', marginRight: '8px' };
  
  switch (type) {
    case 'success':
      return <span style={iconStyle}>✓</span>;
    case 'error':
      return <span style={iconStyle}>✕</span>;
    case 'warning':
      return <span style={iconStyle}>⚠</span>;
    case 'info':
    default:
      return <span style={iconStyle}>ℹ</span>;
  }
};

export default useNotificationWithColors;



// WEBPACK FOOTER //
// ./src/hooks/useNotificationWithColors.js